/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {NbWindowRef} from '@nebular/theme';
import {ApiResponse, BaseComponent, CartSpecification, ProductCustomer, ProductToSpecification, SpecificationService} from 'compob2b-libs';
import {Observable} from 'rxjs';
import {map, takeUntil, tap} from 'rxjs/operators';

@Component({
    selector: 'app-add-to-specification-popup',
    templateUrl: './add-to-specification-popup.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})

export class AddToSpecificationPopupComponent extends BaseComponent implements OnInit {
  product: ProductCustomer;
  amount: number;
  keyword = '';
  submitted = false;
  cartSpecifications: CartSpecification[] = [];
  cartSpecificationsFiltered: CartSpecification[] = [];

  private specifications = new Set<number>();

  constructor(private readonly specificationService: SpecificationService,
              private readonly windowRef: NbWindowRef) {
    super();
  }

  ngOnInit(): void {
    this.loading = true;
    this.pull().pipe(tap(response => this.handlePullResponse(response))).subscribe();
  }

  close() {
    this.windowRef.close();
  }

  private handlePullResponse(response: CartSpecification[]) {
    this.cartSpecifications = this.cartSpecificationsFiltered = response;
    this.loading = false;
    this.cdr.detectChanges();
  }

  onSubmitSpecification() {
    this.submitted = true;

    const data: ProductToSpecification = {
      productId: this.product.id,
      amount: this.amount,
      specifications: Array.from(this.specifications.values())
    };

    return this.specificationService.addProductToSpecifications(data).pipe(
      map((response: ApiResponse<string>) => response.data),
      tap((response: string) => this.handleResponse(response)),
      takeUntil(this.unsubscribe)
    ).subscribe();

  }

  private handleResponse(response: string) {
    this.submitted = false;
    if (response === 'done') {
      this.successToast('Товар добавлен в выбранные спецификации');
      this.close();
    }
    this.cdr.detectChanges();
  }

  private pull(): Observable<CartSpecification[]> {
    return this.compoApiService.get<CartSpecification[]>('/specification').pipe(map(resp => resp.data));
  }

  toggle($event: boolean, id: number) {
    if ($event) {
      if (!this.specifications.has(id)) {
        this.specifications.add(id);
      }
    }
    else {
      if (this.specifications.has(id)) {
        this.specifications.delete(id);
      }
    }
  }

  onKey($event: KeyboardEvent) {
    const regex = new RegExp(this.keyword, 'i');
    this.cartSpecificationsFiltered = this.cartSpecifications.filter(item => item.header.search(regex) !== -1);
  }

  hasSelected() {
    return this.specifications.size > 0;
  }
}
